module.exports = __webpack_public_path__ + "img/portfolio-10.088f12cc.jpg";